import { queryOptions } from '@tanstack/react-query';

import { ONE_MINUTE } from '@/constants/time';
import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

export type SharedAccountTexts = NonNullable<
  paths['/v2/notification-recipients/{accountUserId}']['get']['responses'][200]['content']['application/json']['data']
>;

/**
 * Who gets a support account's texts, and the signed-in staff member's own switch. The API
 * always answers for the real caller, even while they act as another account.
 */
export async function getSharedAccountTextsV2(accountUserId: number) {
  const { data } = await fetchClient.GET('/v2/notification-recipients/{accountUserId}', {
    params: { path: { accountUserId } },
  });

  return data?.data;
}

export function getSharedAccountTextsV2QueryOptions(accountUserId: number, enabled: boolean) {
  return queryOptions({
    queryKey: ['sharedAccountTextsV2', accountUserId],
    queryFn: () => getSharedAccountTextsV2(accountUserId),
    staleTime: ONE_MINUTE,
    enabled,
  });
}

/** Switches the signed-in staff member's own texts for a support account on or off. */
export async function setMySharedAccountTextsV2(accountUserId: number, enabled: boolean) {
  const { data, error } = await fetchClient.PUT('/v2/notification-recipients/{accountUserId}/me', {
    params: { path: { accountUserId } },
    body: { enabled },
  });

  if (!data?.data) {
    throw new Error(error?.error ?? 'Unable to update texts');
  }

  return data.data;
}
